import * as React from "react";
import { ITableItem, tableItemsNoIcons } from "./TableData";
import { ObservableArray, ObservableValue } from "azure-devops-ui/Core/Observable";
import { Button } from "azure-devops-ui/Button";
import { Card } from "azure-devops-ui/Card";
import { renderSimpleCell, Table, TableColumnLayout } from "azure-devops-ui/Table";
import { announce } from "azure-devops-ui/Core/Util/Accessibility";

export default class TableWithAsyncExample extends React.Component {
    // Since we will be changing the items in the table we will use an ObservableArray for our provider.
    // Since we will have async rows, we will define it with the type <T | ObservableValue<T | undefined>>.
    // This allows us to add ITableItem objects directly, as well as ObservableValue's later.
    private itemProvider = new ObservableArray<
        ITableItem | ObservableValue<ITableItem | undefined>
    >(tableItemsNoIcons.value);

    private asyncColumns = [
        {
            columnLayout: TableColumnLayout.singleLinePrefix,
            id: "name",
            name: "Name",
            readonly: true,
            renderCell: renderSimpleCell,
            width: -30,
        },
        { id: "age", name: "Age", readonly: true, renderCell: renderSimpleCell, width: -30 },
        {
            columnLayout: TableColumnLayout.none,
            id: "gender",
            name: "Gender",
            readonly: true,
            renderCell: renderSimpleCell,
            width: -40,
        },
    ];

    public render(): JSX.Element {
        return (
            <div className="flex-column" style={{ width: "100%" }}>
                <Card
                    className="flex-grow bolt-table-card"
                    contentProps={{ contentPadding: false }}
                >
                    <Table<ITableItem>
                        ariaLabel="Table with async"
                        className="table-example"
                        columns={this.asyncColumns}
                        containerClassName="h-scroll-auto"
                        itemProvider={this.itemProvider}
                        role="table"
                    />
                </Card>
                <div style={{ marginTop: "8px" }}>
                    <Button onClick={this.addItem} text="Add Row" />
                </div>
            </div>
        );
    }

    private addItem = () => {
        // To load the row asynchronously create an ObservableValue<T | undefined> and start with
        // the undefined value. The undefined value tells the table the row data is not yet
        // available and the table will render a loading row.
        const asyncRow = new ObservableValue<ITableItem | undefined>(undefined);
        this.itemProvider.push(asyncRow);

        // In this example we just add a small timeout (5 seconds) to simulate the async call to load
        // the row data. After the timeout update the ObservableValue with the row's resulting data.
        window.setTimeout(() => {
            asyncRow.value = {
                age: 0,
                gender: "",
                name: { iconProps: { iconName: "Home" }, text: "Row was loaded async" },
            };
            announce("Asynchronous row loaded", false, 300);
        }, 5000);

        announce("Adding asynchronous row");

        // You will notice in the 1st column a small prefix and a line.  In 3rd column
        // there is no shimmer. These are configured in the column definition. You can control
        // the default behavior of the shimmer by defining a column layout. The default is
        // to render a single line.
    };
}
